import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Spacer from "../Spacer";

export function MenuPanel({
  onClose,
  handleSignOut,
  guidePath,
  dense = false,
}) {
  const { t } = useTranslation();

  const row = dense
    ? "w-full flex flex-row justify-between items-center subtitle-text hover:underline min-h-[40px]"
    : "w-full flex flex-row justify-between items-center subtitle-text hover:underline min-h-[44px]";

  return (
    <div className="flex flex-col gap-1 items-center w-full max-w-lg">
      {/* Close button (optional for desktop; keep for both) */}
      <button
        type="button"
        onClick={onClose}
        aria-label={t("navBar.closeMenu", "Close menu")}
        className="outlined-button self-end mb-2 group"
      >
        <span
          className="material-symbols-outlined text-[24px] text-primary group-hover:text-greyscale-1"
          aria-hidden="true"
        >
          close
        </span>
      </button>

      <button
        type="button"
        onClick={() => {
          onClose();
          handleSignOut();
        }}
        aria-label="Sign out"
        className={row}
      >
        {t("navBar.signOut")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          exit_to_app
        </span>
      </button>

      <Spacer />

      <a
        href="https://www.electronrx.com/terms-and-conditions-addenbrookes"
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.termsConditions", "Terms and Conditions")}
      >
        {t("navBar.termsConditions", "Terms and Conditions")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a>

      <Spacer />

      <a
        href="https://www.electronrx.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.privacy", "Privacy Policy")}
      >
        {t("navBar.privacy", "Privacy Policy")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a>

      <Spacer />

      <a
        href="https://www.electronrx.com/contact-us"
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.contactUs", "Contact Us")}
      >
        {t("navBar.contactUs", "Contact Us")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a>

      <Spacer />

      <Link to="/about" onClick={onClose} className={row}>
        {t("navBar.about", "About")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          arrow_forward_ios
        </span>
      </Link>

      <Spacer />

      <Link to="/profile" onClick={onClose} className={row}>
        {t("navBar.profile", "Profile")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          arrow_forward_ios
        </span>
      </Link>

      {guidePath && (
        <>
          <Spacer />
          <Link to={guidePath} onClick={onClose} className={row}>
            {t("navBar.guide", "Guide")}
            <span
              className="material-symbols-outlined text-[24px]"
              aria-hidden="true"
            >
              arrow_forward_ios
            </span>
          </Link>
        </>
      )}
    </div>
  );
}
